var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssetTypeUncategorised = function SvgAssetTypeUncategorised(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.586 2a1 1 0 0 1 .707.293l3.414 3.414a1 1 0 0 1 .293.707V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4H3a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h1V4a2 2 0 0 1 2-2zM5 9V4a1 1 0 0 1 1-1h8.5v3.5A1.5 1.5 0 0 0 16 8h3v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4h7a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zm14-2h-3a.5.5 0 0 1-.5-.5V3h.086L19 6.414zm-7 3H3v5h9z",
    clipRule: "evenodd"
  })));
};
export default SvgAssetTypeUncategorised;